<template>
  <span class="sf-label" :class="pointerClass" @click="visitUrl">
    <i v-if="showTalkingPointsIcons" class="fa-solid fa-phone" />
    {{ tag.name }}
  </span>
</template>

<script setup lang="ts">
import { RemarkTag } from '@app/shared/types/sf-data'
import { isFeatureSupported } from '@app/adapters/silverfin'
import { computed } from 'vue'
import { useNavigationStore } from '@app/shared/vue/store/navigation-store'

interface Props {
  tag: RemarkTag & { url?: string }
}
const props = defineProps<Props>()

const supportsTalkingPoints = isFeatureSupported('supports_talking_points')

const navigationStore = useNavigationStore()

const pointerClass = computed(() =>
  props.tag.url && window.location.pathname !== props.tag.url
    ? 'tw-cursor-pointer'
    : ''
)

const showTalkingPointsIcons = computed(
  () => props.tag.talkingPoint && supportsTalkingPoints
)

function visitUrl() {
  if (props.tag.url && window.location.pathname !== props.tag.url) {
    navigationStore.enableBackInContext(window.location.href, 'remark_tag', '')

    window.Turbolinks.visit(props.tag.url)
  }
}
</script>
